import { FaRegSquare, FaCheckSquare } from 'react-icons/fa';

import './respostaMultiplaEscolha.css';

export default function RespostaMultiplaEscolha({
  opcoes = [],
  editable = false,
  onToggle,
}) {
  if (!opcoes.length) {
    return <div className="resposta-vazia">Nenhuma opção selecionada</div>;
  }

  return (
    <div className={`resp-bloco ${!opcoes ? 'vazio' : ''}`}>
      <span className="resp-label">Resposta:</span>
      <div className="w-100">
        <ul className="resposta-multipla-lista">
          {opcoes.map((opcao) => {
            const marcada = opcao.opcaoMarcada;

            return (
              <li
                key={opcao.IDQuestao_Opcao}
                className={`resposta-multipla-item ${
                  marcada ? 'selecionada' : ''
                }`}
              >
                {editable ? (
                  <label className="resposta-multipla-input">
                    <input
                      type="checkbox"
                      checked={marcada}
                      onChange={() => onToggle?.(opcao)}
                    />
                    <span className="texto">{opcao.descricaoOpcao}</span>
                  </label>
                ) : (
                  <>
                    <span className="icone">
                      {marcada ? (
                        <FaCheckSquare size={16} />
                      ) : (
                        <FaRegSquare size={16} />
                      )}
                    </span>

                    <span className="texto">{opcao.descricaoOpcao}</span>
                  </>
                )}
              </li>
            );
          })}
        </ul>
      </div>
      {/* {opcoes && (
        <div className="resp-datas">
          <small>
            última atualização:{' '}
            {opcoes.find((o) => o.opcaoMarcada)?.dataUltimaResposta}
          </small>
        </div>
      )} */}
    </div>
  );
}
